//
// frontend validation utils
//

export const marketingRuleRegExp = new RegExp("^(([+!][0-9A-Z]{3})([+/!][0-9A-Z]{3})*)?$");
export const triggerRuleRegExp = new RegExp("^(([+!][0-9_A-Z]{8,16})([+/!][0-9_A-Z]{8,16})*)$");

export const prRuleKeyMapping = (key: string) => {
  return key.replace(/[^a-zA-Z0-9+/!]/g, "").toUpperCase();
};

export const triggerRuleKeyMapping = (key: string) => {
  return key.replace(/[^a-zA-Z0-9_+/!]/g, "").toUpperCase();
};

export const modelCodeKeyMapping = (key: string) => {
  return key.replace(/[^a-zA-Z0-9*]/g, "").toUpperCase();
};

export const alphanumericMappingArray = (keyArray: string[]) => {
  return Array.from(new Set(keyArray.map((key) => alphanumericMapping(key)))).toSorted();
};

export const alphanumericMapping = (key: string) => {
  return key.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
};
